<template>
<div class="index_content">
    <div class="financing_content">
        <Menu mode="horizontal" theme="light" :active-name="page_tab" @on-select="handleSelect">
            <MenuItem name="page1">
                <!-- <i class="iconfont">&#xe663;</i> -->
                投融资总趋势
            </MenuItem>
            <MenuItem name="page2">
                <!-- <i class="iconfont">&#xe665;</i> -->
                当前热点领域
            </MenuItem>
            <MenuItem name="page3">
                <!-- <i class="iconfont">&#xe666;</i> -->
                最新排行榜
            </MenuItem>
            <MenuItem name="page4">
                <!-- <i class="iconfont">&#xe664;</i> -->
                投融资报告
            </MenuItem>
            <div class="top">
              <img class="logo" :src="$store.state.static_img_url+'pic/logo.png'"  @click="haddleApplyTry2(32)">
              <span>提供支持</span>
            </div>
        </Menu>
        <!-- 投融资总趋势 -->
        <div class="data_nav" v-if="page_tab == 'page1'">
            <RadioGroup v-model="all_index" @on-change="allChangeIndex">
                <Radio label="1">
                    <span>融资额</span>
                </Radio>
                <Radio label="2">
                    <span>平均融资额</span>
                </Radio>
                <Radio label="3">
                    <span>融资事件</span>
                </Radio>
                <Radio label="4">
                    <span>领域分布</span>
                </Radio>
                <Radio label="5">
                    <span>轮次分布</span>
                </Radio>
                <Radio label="6">
                    <span>地域分布</span>
                </Radio>
            </RadioGroup>
        </div>

        <p v-if="page_tab == 'page1'" class="data-tip"><i class="iconfont">&#xe654;</i>原始数据采集自公开渠道，可能存在遗漏或错误信息。如需对数据纠错或其他需求咨询，随时联系我们，客服咨询：17338335471</p>

        <FinancingAmount v-if="page_tab == 'page1' && all_index == 1" key="FinancingAmount"></FinancingAmount>
        <AverageAmount v-if="page_tab == 'page1' && all_index == 2" key="AverageAmount"></AverageAmount>
        <FinancingEvent v-if="page_tab == 'page1' && all_index == 3" key="FinancingEvent"></FinancingEvent>
        <FieldDistribution v-if="page_tab == 'page1' && all_index == 4" key="FieldDistribution"></FieldDistribution>
        <RoundDistribution v-if="page_tab == 'page1' && all_index == 5" key="RoundDistribution"></RoundDistribution>
        <ArealDistribution v-if="page_tab == 'page1' && all_index == 6" key="ArealDistribution"></ArealDistribution>
        <!-- 投融资总趋势 end -->

        <!-- 当前热点领域 -->
        <div class="data_nav" v-if="page_tab == 'page2'">
            <RadioGroup v-model="field_index" @on-change="fieldChangeIndex">
                <Radio label="1">
                    <span>融资事件</span>
                </Radio>
                <Radio label="2">
                    <span>融资额</span>
                </Radio>
                <Radio label="3">
                    <span>轮次分布</span>
                </Radio>
            </RadioGroup>
        </div>
        <p v-if="page_tab == 'page2'" class="data-tip"><i class="iconfont">&#xe654;</i>原始数据采集自公开渠道，可能存在遗漏或错误信息。如需对数据纠错或其他需求咨询，随时联系我们，客服咨询：17338335471</p>
        <FieldEvent v-if="page_tab == 'page2' && field_index == 1" key="FieldEvent" :tagmap="meta.getyttagmap"></FieldEvent>
        <FieldAmount v-if="page_tab == 'page2' && field_index == 2" key="FieldAmount" :tagmap="meta.getyttagmap"></FieldAmount>
        <FieldRound v-if="page_tab == 'page2' && field_index == 3" key="FieldRound" :tagmap="meta.getyttagmap"></FieldRound>
        <!-- 当前热点领域 end -->

        <!-- 最新Top30 -->
        <div class="data_nav" v-if="page_tab == 'page3'">
            <RadioGroup v-model="top_index" @on-change="topChangeIndex">
                <Radio label="1">
                    <span>融资额Top30</span>
                </Radio>
                <Radio label="2">
                    <span>投资机构Top30</span>
                </Radio>
                <Radio label="3">
                    <span>FA排行Top10</span>
                </Radio>
            </RadioGroup>
        </div>
        <!-- <p v-if="page_tab == 'page3'" class="data-tip"><i class="iconfont">&#xe654;</i>原始数据采集自公开渠道，可能存在遗漏或错误信息。如需对数据纠错或其他需求咨询，随时联系我们，客服咨询：13627682184（微信同号）</p> -->
        <AmountTop v-if="page_tab == 'page3' && top_index == 1"></AmountTop>
        <OrgTop v-if="page_tab == 'page3' && top_index == 2"></OrgTop>
        <FaTop v-if="page_tab == 'page3' && top_index == 3"></FaTop>
        <!-- 最新Top30 end -->
        <ReportList v-if="page_tab == 'page4'"></ReportList>
    </div>
</div>
</template>

<script>
// 投融资总趋势
import FinancingAmount from './components/pageTab1/FinancingAmount'  // 融资金额
import AverageAmount from './components/pageTab1/AverageAmount'  // 平均融资额
import FinancingEvent from './components/pageTab1/FinancingEvent'  // 融资事件
import FieldDistribution from './components/pageTab1/FieldDistribution'  // 领域分布
import RoundDistribution from './components/pageTab1/RoundDistribution'  // 轮次分布
import ArealDistribution from './components/pageTab1/ArealDistribution'  // 地域分布
// 当前热点领域
import FieldEvent from './components/pageTab2/FieldEvent'  // 热点领域融资事件
import FieldAmount from './components/pageTab2/FieldAmount'  // 热点领域融资金额
import FieldRound from './components/pageTab2/FieldRound'  // 热门领域轮次分布
// 最新Top30
import AmountTop from './components/pageTab3/AmountTop'  // 融资额Top30
import OrgTop from './components/pageTab3/OrgTop'  // 投资机构Top30
import FaTop from './components/pageTab3/FaTop'  // fa机构Top30
// 投融资报告
import ReportList from './components/pageTab4/ReportList'  // 投融资报告

import { getAddPuv } from 'js/addPuv.js'
import { get_meta } from 'js/get_meta'

export default {
  inject: ['haddleApplyTry2'],
  mixins: [getAddPuv, get_meta],
  components: {
    FinancingAmount,AverageAmount,FinancingEvent,FieldDistribution,RoundDistribution,ArealDistribution,
    FieldEvent,FieldAmount,FieldRound,
    AmountTop,OrgTop,FaTop,
    ReportList
  },
  provide() {
    return {
      page_tab: this.page_tab,
      all_index: this.all_index,
      field_index: this.field_index,
      top_index: this.top_index,
      pageShowOrCancel: this.pageShowOrCancel
    }
  },
  data() {
    return {
      page_tab: 'page1', // 投融资总趋势 page1 , 当前热点领域 page2 , 最新Top30 page3 , 投融资报告 page4
      all_index: '1', // 投融资总趋势：融资金额 1 , 平均融资额 2 , 融资事件 3 , 领域分布 4 , 轮次分布 5 , 地域分布 6
      field_index: '1', // 当前热点领域：融资事件 1 , 融资额 2, 轮次分布 3
      top_index: '1', // 最新Top30：融资额Top30 1 , 投资机构Top30 2, fa机构Top30 3
      fromPath: ''
    }
  },
  methods: {
    handleSelect(name) {
      if(name == 'page1'){
        _czc.push(['_trackEvent', '投融资页面', '投融资tab切换点击（投融资总趋势）'])
      }
      else if(name == 'page2'){
        _czc.push(['_trackEvent', '投融资页面', '投融资tab切换点击（当前热点领域）'])
      }
      else if(name == 'page3'){
        _czc.push(['_trackEvent', '投融资页面', '投融资tab切换点击（最新Top30）'])
      }
      else if(name == 'page4'){
        _czc.push(['_trackEvent', '投融资页面', '投融资tab切换点击（投融资报告）'])
      }
      this.page_tab = name
    },
    allChangeIndex(val) {
      if(val == '1'){
        _czc.push(['_trackEvent', '投融资页面', '投融资总趋势筛选点击（融资额）'])
      }
      else if(val == '2'){
        _czc.push(['_trackEvent', '投融资页面', '投融资总趋势筛选点击（平均融资额）'])
      }
      else if(val == '3'){
        _czc.push(['_trackEvent', '投融资页面', '投融资总趋势筛选点击（融资事件）'])
      }
      else if(val == '4'){
        _czc.push(['_trackEvent', '投融资页面', '投融资总趋势筛选点击（领域分布）'])
      }
      else if(val == '5'){
        _czc.push(['_trackEvent', '投融资页面', '投融资总趋势筛选点击（轮次分布）'])
      }
      else if(val == '6'){
        _czc.push(['_trackEvent', '投融资页面', '投融资总趋势筛选点击（地域分布）'])
      }
    },
    fieldChangeIndex(val) {
      if(val == '1'){
        _czc.push(['_trackEvent', '投融资页面', '当前热点领域筛选点击（融资事件）'])
      }
      else if(val == '2'){
        _czc.push(['_trackEvent', '投融资页面', '当前热点领域筛选点击（融资额）'])
      }else if(val == '3'){
        _czc.push(['_trackEvent', '投融资页面', '当前热点领域筛选点击（轮次分布）'])
      }
    },
    topChangeIndex(val) {
      if(val == '1'){
        _czc.push(['_trackEvent', '投融资页面', '最新top30筛选点击（融资额Top30）'])
      }
      else if(val == '2'){
        _czc.push(['_trackEvent', '投融资页面', '最新top30筛选点击（投资机构Top30）'])
      }
    }
  },
  created() {
    this.getMeta(['getyttagmap'])

    let url = window.location.href
    this.getAddPuv(url)

    if(this.$store.state.financing_index != '') {
      this.page_tab = this.$store.state.financing_index.page_tab
      this.all_index = this.$store.state.financing_index.all_index
      this.field_index = this.$store.state.financing_index.field_index
      this.top_index = this.$store.state.financing_index.top_index
    }
    this.fromPath = this.$route.query.fromPath
    if (this.fromPath == 'track') {
      this.page_tab = 'page4'
    }
    if (this.fromPath == 'company') {
      this.page_tab = 'page3'
      this.top_index = '2'
    }
    if (this.fromPath == 'tagcloud') {
      this.page_tab = 'page2'
    }
  },
  beforeDestroy() {
    this.$store.commit('updateFinancingIndex', {
      page_tab: this.page_tab,
      all_index: this.all_index,
      field_index: this.field_index,
      top_index: this.top_index
    })
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.index_content
  padding: 16px 0 20px
  .financing_content
    commonBgColor(#1F2330,#ffffff)
    .ivu-menu-light
      commonBgColor(#2A2F42,#FFFAF5)
      height: 50px
      line-height: 50px
      z-index: 2
      box-shadow: 0 1px 0 0 rgba(255,255,255,0.10)
      &:after
        content: none
      .ivu-menu-item
        font-size: 15px
        padding: 0 6px
        commonColor(#BCBDC1, #999999)
        width: 200px
        text-align: center
        height: 52px
        border-bottom: 0
        &:hover
          border-color: transparent
          color: rgba(250, 122, 80, 1)
      .ivu-menu-item-active
        border-color: rgba(250, 122, 80, 1)
        commonBgColor(#1F2330, #ffffff)
        font-weight: bold
        border-top: 2px solid rgba(250, 122, 80, 1)
        commonColor(#e9e9eb, #333333)
        i
          font-weight: normal
        &:hover
          border-color: rgba(250, 122, 80, 1)
      .top
        float right
        display flex
        justify-content center
        align-items center
        margin-right 20px
        height 50px
        span
          font-size 12px
          color #999
          margin-left 10px
        .logo
          height 16px
          cursor pointer
    .data_nav
      margin: 20px 30px
      .ivu-radio-wrapper
        commonBgColor(#2A2F42, #ffffff)
        padding: 13px 16px
        margin-right: 16px
        border: 1px solid
        commonBorderColor(transparent, #E9E9E9)
        & >>> .ivu-radio
          font-size: 0
          margin-right: 8px
          .ivu-radio-inner
            display: inline-block
            vertical-align: top
            background: transparent
            commonBorderColor(#7A7F94, #D5D5D5)
            &:after
              background-color: #fff
          &:hover
            .ivu-radio-inner
              commonBorderColor(rgba(250, 122, 80, 1), #23294D)
          &.ivu-radio-checked
            .ivu-radio-inner
              commonBorderColor(rgba(250, 122, 80, 1), #23294D)
              commonBgColor(rgba(250, 122, 80, 1), #23294D)
          &-focus
            box-shadow: none
        span.ivu-radio+*
          font-size: 14px
          commonColor(#BCBDC1, #333333)
          vertical-align: top
          display: inline-block
          margin: 0
          &:hover
            color: rgba(250, 122, 80, 1) !important
    .data-tip
      height: 44px
      commonBgColor(#113056, #F2FAFF)
      commonColor(#E9E9EB, #666666)
      font-size:14px
      line-height: 20px
      padding: 12px 20px
      margin: 0 30px
      .iconfont
        color: #69c0ff
        font-size: 20px
        margin-right: 12px
        inlineBlock()
</style>
